import request from '@/utils/request';
import router from '@/router';

/* eslint-disable */
const actions = {
  async addBrand({ dispatch, commit }, brand) {
    try {
      const { data } = await request.post('brands', brand);

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      router.push({ name: "products.brands.edit", params: { uuid: data.brand.uuid } });
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
